import { useEffect, useState } from "react";
import { getLegalCurrent } from "@/lib/s2tApi";
import { X } from "lucide-react";

// Renders the EXISTING Source2Table legal documents (fetched live from the
// production API) in a modal. Read-only display.
export const LegalModal = ({ open, onClose, initialKind }) => {
  const [docs, setDocs] = useState([]);
  const [active, setActive] = useState(initialKind || "terms_of_service");
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!open) return;
    getLegalCurrent()
      .then((d) => setDocs(d.documents || []))
      .catch(() => setErr(true));
  }, [open]);

  useEffect(() => {
    if (initialKind) setActive(initialKind);
  }, [initialKind]);

  if (!open) return null;
  const current = docs.find((d) => d.kind === active);

  return (
    <div
      data-testid="legal-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50"
      onClick={onClose}
    >
      <div
        className="bg-[#F9F6F0] w-full max-w-3xl max-h-[85vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#D8E0D5]">
          <h3 className="font-sans font-extrabold text-lg text-[#1C241B]">Legal</h3>
          <button
            data-testid="legal-modal-close"
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-[#4A6B41]/10 text-[#2F4829]"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
        <div className="flex flex-wrap gap-2 px-5 py-3 border-b border-[#D8E0D5]">
          {docs.map((d) => (
            <button
              key={d.kind}
              data-testid={`legal-tab-${d.kind}`}
              onClick={() => setActive(d.kind)}
              className={`text-xs font-semibold rounded-full px-3 py-1.5 ${
                active === d.kind
                  ? "bg-[#4A6B41] text-[#F9F6F0]"
                  : "bg-white text-[#2F4829] border border-[#D8E0D5]"
              }`}
            >
              {d.title}
            </button>
          ))}
        </div>
        <div className="px-5 py-4 overflow-y-auto">
          {err && (
            <p className="text-sm text-[#5A6757]">
              Unable to load legal documents right now.
            </p>
          )}
          {current ? (
            <pre className="whitespace-pre-wrap font-sans text-sm text-[#2b332a] leading-relaxed">
              {current.body}
            </pre>
          ) : (
            !err && <p className="text-sm text-[#5A6757]">Loading…</p>
          )}
        </div>
      </div>
    </div>
  );
};
